export default __webpack_public_path__ + "ae1eecc77cac5bb4bc9499920cd04515.svg";